/* ============================================================================
   GEO REDIRECT MODAL  —  pure JS

   Split out of the inline <script>. Logic unchanged. The only Liquid in the
   original was:

       {% if localization.country.iso_code != blank %}
         var shopifyCountry = {{ localization.country.iso_code | json }};
         ...
       {% endif %}

   That value now arrives as window.__geoRedirectConfig.shopifyCountry, emitted
   inline before this file loads. The Liquid block emits null when the code is
   blank, and the original's `if (shopifyCountry && ...)` truthiness check
   already treated a missing value as "fall through to the ipapi lookup" — so
   the gate behaves identically.

   ⚠ FLASH-OF-MODAL: the last statement used to hide the overlay DURING parsing.
   With `defer` it runs after the document is parsed, so if the overlay is not
   already hidden by CSS it can flash on every page load. See the note in the
   Liquid tags file — add `display: none` to #geo-redirect-overlay in your
   stylesheet.
   ============================================================================ */

(function () {
  'use strict';

  var CFG = window.__geoRedirectConfig || {};

  var STORAGE_KEY  = 'nintarababy_geo_dismissed';
  var REDIRECT_URL = 'https://nintarababy.in';
  var HOME_COUNTRY = 'US';

  var COUNTRY_MAP = {
    IN: { name: 'India'              },
    GB: { name: 'the United Kingdom' },
    CA: { name: 'Canada'             },
    AU: { name: 'Australia'          },
    DE: { name: 'Germany'            },
    FR: { name: 'France'             },
    NL: { name: 'the Netherlands'    },
    SG: { name: 'Singapore'          },
    AE: { name: 'the UAE'            },
    NZ: { name: 'New Zealand'        },
    JP: { name: 'Japan'              },
    ZA: { name: 'South Africa'       },
  };

  var lastFocused = null;
  var listenersBound = false;

  function getFlagUrl(code) {
    return 'https://flagcdn.com/w80/' + code.toLowerCase() + '.png';
  }

  function dismissed() {
    try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch(e) { return false; }
  }

  function setDismissed() {
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch(e) {}
  }

  function getFocusable(container) {
    var nodes = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.slice.call(nodes).filter(function (el) {
      return el.offsetParent !== null || el.getClientRects().length > 0;
    });
  }

  function closeModal() {
    var overlay = document.getElementById('geo-redirect-overlay');
    if (!overlay) return;

    setDismissed();
    overlay.classList.add('geo-hidden');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    setTimeout(function () {
      overlay.style.display = 'none';
      // Restore focus to the element that had focus before the modal opened
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus(); } catch (e) {}
      }
    }, 200);
  }

  function onOverlayKeydown(e) {
    var overlay = document.getElementById('geo-redirect-overlay');
    if (!overlay) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.stopPropagation();
      closeModal();
      return;
    }

    if (e.key !== 'Tab') return;

    var focusable = getFocusable(overlay);
    if (!focusable.length) {
      e.preventDefault();
      return;
    }

    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    var active = document.activeElement;

    // If focus has escaped the overlay (e.g. landed on body), bring it back
    if (!overlay.contains(active)) {
      e.preventDefault();
      first.focus();
      return;
    }

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onOverlayClick(e) {
    var overlay = document.getElementById('geo-redirect-overlay');
    if (e.target === overlay) closeModal();
  }

  function bindListeners() {
    if (listenersBound) return;
    var overlay      = document.getElementById('geo-redirect-overlay');
    var redirectBtn  = document.getElementById('geo-redirect-btn');
    var dismissBtn   = document.getElementById('geo-dismiss-btn');
    if (!overlay || !redirectBtn || !dismissBtn) return;

    redirectBtn.addEventListener('click', function () {
      window.location.href = REDIRECT_URL;
    });
    dismissBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', onOverlayClick);
    overlay.addEventListener('keydown', onOverlayKeydown);

    listenersBound = true;
  }

  function showModal(countryCode) {
    var info    = COUNTRY_MAP[countryCode] || { name: countryCode };
    var overlay = document.getElementById('geo-redirect-overlay');
    if (!overlay) return;

    // Cache currently-focused element so we can restore on close
    lastFocused = document.activeElement;

    document.getElementById('geo-country-name').textContent = info.name;

    var flagImg = document.getElementById('geo-flag-img');
    flagImg.src = getFlagUrl(countryCode);
    flagImg.alt = info.name + ' flag';

    document.body.style.overflow = 'hidden';

    overlay.style.display = 'flex';
    overlay.classList.remove('geo-hidden');
    overlay.setAttribute('aria-hidden', 'false');

    bindListeners();

    // Move focus to the primary action so screen readers announce dialog title
    // via aria-labelledby and keyboard users can act immediately
    var redirectBtn = document.getElementById('geo-redirect-btn');
    if (redirectBtn) {
      try { redirectBtn.focus(); } catch (e) {}
    }
  }

  function init() {
    if (dismissed()) return;

    // Was the {% if localization.country.iso_code != blank %} block. The Liquid
    // emits null when blank, and this truthiness check already handled that —
    // blank falls through to the ipapi lookup below, exactly as before.
    var shopifyCountry = CFG.shopifyCountry;
    if (shopifyCountry && shopifyCountry !== HOME_COUNTRY) {
      showModal(shopifyCountry);
      return;
    }

    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var code = (data && data.country_code) ? data.country_code.toUpperCase() : '';
        if (code && code !== HOME_COUNTRY) showModal(code);
      })
      .catch(function () {});
  }

  var overlay = document.getElementById('geo-redirect-overlay');
  if (overlay) overlay.style.display = 'none';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
